// Import model
import { SearchMetaData } from '../models/SearchMetaData';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SearchHighlights } from '../models/SearchHighlights';

// Import dependency serializers (for complex types)
import { SearchHighlightsSerializer } from './SearchHighlightsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SearchMetaData - handles JSON serialization and deserialization with type validation
 */
export class SearchMetaDataSerializer {
  /**
   * Deserializes a JSON string into a SearchMetaData instance
   */
  static deserialize(json: string): SearchMetaData {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SearchMetaData instance
   */
  static fromObject(obj: any): SearchMetaData {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SearchMetaData');
    }


    const instance: SearchMetaData = {
      score: obj['score'] as number | undefined,
      highlights: obj['highlights'] ? (obj['highlights'] as any[]).map((item: any) =>
        SearchHighlightsSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SearchMetaData instances
   */
  static deserializeArray(json: string): SearchMetaData[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SearchMetaData instance to a JSON string
   */
  static serialize(instance: SearchMetaData): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SearchMetaData instance to a plain object
   */
  static toObject(instance: SearchMetaData): any {
    return {
      'score': instance.score,
      'highlights': instance.highlights?.map((item: any) =>
        SearchHighlightsSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of SearchMetaData instances to a JSON string
   */
  static serializeArray(instances: SearchMetaData[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
